module.exports = __webpack_public_path__ + "img/title_agenda.421a45a6.png";